import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@views/LoginView.vue'
import HomeView from '@views/HomeView.vue'
import AccessView from '@views/AccessView.vue'
import CostQueryView from '@views/CostQueryView.vue'
import QueryHistoryView from '@views/QueryHistoryView.vue'
import BatchQueryView from '@views/BatchQueryView.vue'
import CrmCustomerView from '@views/CrmCustomerView.vue'
import CostManagementView from '@views/CostManagementView.vue'
import SubUserManagementView from '@views/SubUserManagementView.vue'
import SubUserCostQueryView from '@views/SubUserCostQueryView.vue'
import { useWuliu178AuthStore } from '@store/auth.js'



export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/home',
      name: 'home',
      component: CostQueryView
    },
    {
      path: '/access',
      name: 'access',
      component: AccessView
    },
    {
      path: '/cost-query',
      name: 'cost-query',
      component: CostQueryView
    },
    {
      path: '/query-history',
      name: 'query-history',
      component: QueryHistoryView
    },
    {
      path: '/batch-query',
      name: 'batch-query',
      component: BatchQueryView
    },
    {
      path: '/crm-customer',
      name: 'crm-customer',
      component: CrmCustomerView
    },
    {
      path: '/cost-management',
      name: 'cost-management',
      component: CostManagementView
    },
    {
      path: '/sub-users',
      name: 'sub-users',
      component: SubUserManagementView
    },
    {
      path: '/sub-user-cost-query',
      name: 'sub-user-cost-query',
      component: SubUserCostQueryView
    },
    {
      path: '/',
      name: 'homepage',
      component: CostQueryView
    },


  ]
})

// 子用户登录后只能使用独立的价格查询页（不展示成本价）
router.beforeEach((to) => {
  const wlAuth = useWuliu178AuthStore()
  const isSubUser = !!wlAuth.userProfile?.is_sub_user
  if (isSubUser && ['/', '/home', '/cost-query'].includes(to.path)) {
    return '/sub-user-cost-query'
  }
  if (!isSubUser && to.path === '/sub-user-cost-query') {
    return '/cost-query'
  }
})
